import { Alert, Table, Tooltip, Typography } from "antd";
import React, { useContext, useEffect, useState } from "react";
import { GenericAccountsTable } from "../../../components/tables/AccountsTable";
import Account from "../../../models/Account";
import { useNavigate } from "react-router-dom";
import { Modes } from "../../../Modes";
import InfoBox from "../../../components/InfoBox";
import { AccountForms } from "../../../components/forms/AccountForm";
import { NavigationContext } from "../../../context/NavigationContext";
import { GenericTableActions } from "../../../components/tables/types";
import { ToastContext } from "../../../context/ToastContext";
import AccountService from "../../../services/crud/AccountService";
const adminActions: GenericTableActions = { add: true, delete: true, view: true, select: true };

type Props = {};
/**
 * This page lists all real estate accounts
 * @param param0
 * @returns
 */
function RealEstateAccounts({}: Props) {
  const { user, mode } = useContext(NavigationContext);
  const navigate = useNavigate();
  // CASE: USER HAS ONE REAL ESTATE ACCOUNT
  useEffect(() => {
    switch (mode) {
      case Modes.SYSTEM_ADMIN:
        break;
      case Modes.COMPANY_ADMIN:
        AccountService.list({ userId: user?.id, type: Account.types.REAL_ESTATE }).then((accounts) => {
          if (accounts.length === 1) {
            navigate("/realEstates/" + accounts[0].id);
          }
        });
        break;
      case Modes.REAL_ESTATE_ADMIN:
        AccountService.list({ userId: user?.id, type: Account.types.REAL_ESTATE }).then((accounts) => {
          if (accounts.length === 1) {
            navigate("/realEstates/" + accounts[0].id);
          }
        });
        break;
    }
  }, [user, mode, navigate]);
  let accountsTable = <></>;
  switch (mode) {
    case Modes.SYSTEM_ADMIN:
      accountsTable = (
        <GenericAccountsTable
          formCreate={AccountForms.RealEstateCreate}
          actions={adminActions}
          params={{ type: Account.types.REAL_ESTATE }}
          onView={(account) => {
            navigate("/realEstates/" + account.id);
          }}
          excludeColumns={[
            "type", "balance", "whiteLabelId", "hasBikeShare", "hasMabiCarShare", "hasKintoShare", "authorizedDomains",
            "defaultAllowBookByInvoice",
          ]}
        ></GenericAccountsTable>
      );
      break;
    case Modes.COMPANY_ADMIN:
      accountsTable = <AccountsTable params={{ type: Account.types.REAL_ESTATE, userId: user?.id }}></AccountsTable>;
      break;
    case Modes.REAL_ESTATE_ADMIN:
      accountsTable = <AccountsTable params={{ type: Account.types.REAL_ESTATE, userId: user?.id }}></AccountsTable>;
      break;
  }
  return (
    <div>
      <Typography.Title>Real estates</Typography.Title>
      {accountsTable}
    </div>
  );
}

export default RealEstateAccounts;

/**
 * This table loads data from backend and filters based on dataFilter and columnFilter.
 * @param {number} userId - default undefined. If defined loads alla accounts related to user
 * @param {function} dataFilter - filters data
 * @param {function} columnFilter - filter columns based on key
 * @returns table populated with accounts
 */
function AccountsTable({ params = {}, userId = undefined, dataFilter = (data: Account) => true, columnFilter = (col) => true }) {
  /// A function (account) => boolean, that is passed to filter() function
  /// to filter out which accounts to keep.
  // Similarly an optional function to filter which columns to keep
  const { user } = useContext(NavigationContext);
  const [accounts, setAccounts] = useState<Array<Account>>([]);
  const [filter, setFilter] = useState("");

  const { loading, loadMessage } = useContext(ToastContext);

  const navigate = useNavigate();
  const gotoPage = (route) => {
    console.log("route is: " + route);
    navigate("/realEstates/" + route);
  };
  function loadTable(user) {
    if (user) {
      loadMessage("Loading Accounts...", () =>
        Promise.all([AccountService.list(params)]).then((data) => {
          const accounts = data[0].filter(dataFilter);
          accounts.sort((a, b) => a?.name?.toLowerCase().localeCompare(b?.name?.toLowerCase()));
          setAccounts(accounts);
        })
      );
    }
  }
  useEffect(() => {
    loadTable(user);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  const filterTable = (data) => {
    const filterLc = filter.toLocaleLowerCase();
    return data.filter((item) => item.toString().toLocaleLowerCase().indexOf(filterLc) !== -1);
  };

  var columns: any = [
    {
      title: "Name",
      key: "name", // Used by UserProfile via columnFilter prop
      dataIndex: ["name"],
      render: (text, record, index) => {
        return <Tooltip title={`${record?.name ?? ""}`.trim()}>{record?.name ?? ""}</Tooltip>;
      },
      sorter: (a, b) => a?.name?.toLowerCase().localeCompare(b?.name?.toLowerCase()),
    },
    {
      title: "Users",
      key: "userCount",
      dataIndex: ["userCount"],
      render: (text, record, index) => {
        return <Typography.Text>{record.userCount || 0}</Typography.Text>;
      },
      sorter: (a, b) => (a?.userCount ?? 0) - (b?.userCount ?? 0),
    },
    {
      title: "Hubs",
      key: "hubs",
      dataIndex: ["hubs"],
      render: (text, record, index) => {
        return <Typography.Text>{text?.length || 0}</Typography.Text>;
      },
      sorter: (a, b) => (a?.hubs?.length ?? 0) - (b?.users?.hubs ?? 0),
    },

    // {
    //   title: "Mobility Services",
    //   dataIndex: ["subscriptions"],
    //   render: (text, record, index) => {
    //     return <Typography.Text>{text?.length || 0}</Typography.Text>;
    //   },
    //   // sorter: (a, b) => a.createdAt.localeCompare(b.createdAt),
    // },
  ];
  // Filters
  const filterColumns = (columns = []) => columns.filter(columnFilter);

  return (
    <div>
      {/* <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 24 }}>
        <div>
          <Popconfirm
            title={"You are about to delete " + selectedRows.length + " accounts!"}
            open={open}
            onConfirm={handleOk}
            okButtonProps={{ loading: confirmLoading }}
            onCancel={handleCancel}
          >
            <Button type="primary" onClick={showPopconfirm}>
              Delete Accounts
            </Button>
          </Popconfirm>
          <Input.Search size="middle" placeholder="Search accounts..." style={{ width: 200 }} onChange={(e) => setFilter(e.target.value)} />
          <span style={{ marginLeft: 8 }}>{hasSelected ? `Selected ${selectedRows.length} items` : ""}</span>
        </div>
        <Button type="primary" size="middle" onClick={() => openCreateModal()}>
          Create new account
        </Button>
      </div> */}

      <Table
        bordered
        rowKey="id"
        // rowSelection={rowSelection}
        columns={filterColumns(columns)}
        dataSource={filterTable(accounts)}
        // pagination={{ total: accounts.length, defaultPageSize: 30, showSizeChanger: true }}
        onRow={(record) => ({ onClick: () => gotoPage(record.id) })}
        loading={loading}
      />
      {/* <Typography.Text style={{ position: "relative", top: -43, left: 10, color: "#bfbfbf" }}>Total of {accounts.length} accounts</Typography.Text> */}
    </div>
  );
}
